import { CheckCircle, Clock } from '@untitled-ui/icons-react/build/cjs';
import React from 'react';

import AiOrb, { type AiOrbAgent } from './AiOrb';

export type AiTaskStatus = 'working' | 'done' | 'awaiting';
export type AiTaskAgent = AiOrbAgent;

interface IProps {
    /** Mandatory heading (e.g. "Quoting Agent", "Reading your inbox...") */
    title: string;
    status: AiTaskStatus;
    /** Agent key. When omitted the orb renders gray. */
    agent?: AiTaskAgent | null;
    /** Time label shown alongside the status indicator. A string (e.g. "3m 4s") or a node
     * (e.g. a live <LiveElapsedTimer/> that ticks every second). */
    time?: React.ReactNode;
}

const AiTaskHeader = ({ title, status, agent, time }: IProps) => (
    <div className="flex items-center gap-x-2 !mt-5">
        <AiOrb agent={agent} animated />

        {/* Title */}
        <span className="text-xs leading-[1.5] font-medium text-grayLight900 flex-1 truncate">{title}</span>

        {/* Status indicator */}
        <div className="flex items-center gap-x-1 flex-shrink-0">
            {status === 'working' ? (
                <span className="inline-flex gap-x-[3px] agentspace-timer-dot-animation">
                    <i></i>
                    <i></i>
                    <i></i>
                </span>
            ) : status === 'done' ? (
                <CheckCircle className="w-3.5 h-3.5 text-fgSuccessPrimary flex-none" />
            ) : (
                <Clock className="w-3.5 h-3.5 text-gray400 flex-none" />
            )}

            <span className="text-xs leading-[1.5] text-gray500 font-normal">{status === 'awaiting' ? 'Awaiting Input' : time && time}</span>
        </div>
    </div>
);

export default AiTaskHeader;
